const NID_REGEXP = /^([a-z]|å|ä|ö|ø|æ|ô|[0-9]|-|_| )+$/i

const ISO_DATE_REGEXP = /^\d{4}-\d{2}-\d{2}$/

export { ISO_DATE_REGEXP, NID_REGEXP }
